"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenTable = void 0;
const throttle_1 = __importDefault(require("lodash/throttle"));
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const styled_components_1 = __importStar(require("styled-components"));
const react_i18next_1 = require("react-i18next");
const common_1 = require("../../../common");
const option_1 = require("../../../common/option");
const GlobalStateProvider_1 = require("../../../GlobalStateProvider");
const posts_1 = require("../../../server/posts");
const constant_1 = require("../../DST/DSTSL001/constant");
const DeleteResourceItem_1 = require("../../DST/DSTSL001/DSTSL001_List_Child/DeleteResourceItem");
const action_1 = require("../../menu/action");
const OpenItem_1 = require("./OpenItem");
const OpenTableStyled = styled_components_1.default.div `
	height: 100%;
	.body-item {
		p {
			${props => props.$isHome &&
    `
				overflow: hidden;
				text-overflow: ellipsis;
				word-break: keep-all;
				overflow-wrap: break-word;
				white-space: nowrap;
				-webkit-line-clamp: 1;`}
			${props => props.$isDesktop
    ? `
						font-size: var(--b3-font-size, 16px);
						line-height: var(--b3-line-height, 32px);
						letter-spacing: var(--b3-letter-spacing, -0.02em);
						font-weight: var(--b3-font-weight, 400);		
				`
    : props.$isTablet
        ? `
						font-size: var(--b4-font-size, 14px);
						line-height: var(--b4-line-height, 28px);
						letter-spacing: var(--b4-letter-spacing, -0.02em);
						font-weight: var(--b4-font-weight, 400);`
        : `
						font-size: var(--b4-font-size, 12px);
						line-height: var(--b4-line-height, 24px);
						letter-spacing: var(--b4-letter-spacing, -0.02em);
						font-weight: var(--b4-font-weight, 400);`}
		}
	}

	${props => props.$isHome &&
    props.$isMobile &&
    `
			.mobile_item {
				flex-direction: row !important;
			    justify-content: space-between !important;
			}
			.body-item {
				overflow: hidden;
    			flex: unset !important;

				&.creation_time {
					min-width: 100px;
					p {
						text-align: right;
					}
				}
			}
		`}

	${props => props.$isHome &&
    `
				.body-item {
					&.creation_time {
						width: 100px!important;
						flex: unset !important;

						p {
							width: 100%;
							text-align: right;
						}
					}
				}
			`}

	.home-title {
		display: flex;
		flex-direction: row;
		gap: 8px;
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
		width: 100%;

		.must-read {
			color: var(--color-pink, #f46790);
			text-align: left;
			font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
			font-weight: var(--h5-font-weight, 700);

			position: relative;
			display: flex;
			align-items: center;
			justify-content: flex-start;
		}

		.name {
			color: var(--color-black, #101010);
			text-align: left;
			font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
			position: relative;

			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
		}

		.file-value {
			display: flex;
			flex-direction: row;
			gap: 4px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;
		}
	}

	.file {
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 8px;
	}
	.item {
		.pink {
			color: var(--color-pink, #f46790);
			text-align: center;
			font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b3-font-size, 16px);
			line-height: var(--b3-line-height, 32px);
			font-weight: var(--b3-font-weight, 400);
			position: relative;
			display: flex;
			align-items: center;
		}

		.purple {
			color: var(--pur-d, #8268d9);
			text-align: center;
			font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b3-font-size, 16px);
			line-height: var(--b3-line-height, 32px);
			font-weight: var(--b3-font-weight, 400);
			position: relative;
			display: flex;
			align-items: center;
		}
	}

	.resource-content {
		width: 100%;
	}

	.notice-list-001 {
		width: 100%;
	}

	.home-list-003 {
		height: 100%;
	}

	${props => (props.$isDesktop ? desktopStyles : props.$isTablet ? tabletStyles : mobileStyles)}
`;
const mobileStyles = (0, styled_components_1.css) `
	display: flex;
	width: 100%;
	flex-direction: column;
	/* height: 100%; */
	&.home {
		height: 100%;
	}

	.body-checkbox {
		padding-bottom: 4px;
	}

	.importance {
		min-width: fit-content;
		top: 9px;
		position: absolute;
		left: 30px;
		font-size: 12px !important;
		font-weight: 500 !important;
		font-family: 'Noto Sans KR' !important;
	}

	.notice-list-001 {
		display: flex;
		flex-direction: column;
		gap: ${props => (props.$isTeacher ? '12px' : '0px')};
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		flex: 1;
		position: relative;
		padding: 0 20px;
		overflow-x: hidden;

		.table-header {
			display: flex;
			flex-direction: row;
			gap: 24px;
			align-items: center;
			justify-content: flex-start;
			align-self: stretch;
			flex-shrink: 0;
			position: relative;

			p {
				color: var(--color-grey, #666666);
				text-align: left;
				font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
				font-size: var(--b3-font-size, 16px);
				line-height: var(--b3-line-height, 32px);
				font-weight: var(--b3-font-weight, 400);
				position: relative;
				display: flex;
				align-items: center;
				justify-content: flex-start;
			}
		}

		.scroll-content {
			display: flex;
			flex-direction: column;
			gap: 0px;
			align-items: center;
			align-self: stretch;
			flex: 1;
			position: relative;
			box-sizing: border-box;
		}

		.item {
			border-style: solid;
			border-color: var(--color-grey-c, #e6e8ed);
			border-width: ${props => (props.$isTeacher ? '1px 0px 0px 0px' : '0px 0px 1px 0px')};
			padding: 12px 0px 12px 0px;
			display: flex;
			flex-direction: column;
			// gap: 4px;
			align-items: flex-start;
			justify-content: center;
			align-self: stretch;
			flex-shrink: 0;
			position: relative;
			width: 100%;

			.file {
				text-align: left;
				position: relative;
				display: flex;
				align-items: center;
				justify-content: center;
				gap: 4px;
			}
		}
	}

	.home-list-003 {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;

		.scroll-content {
			display: flex;
			flex-direction: column;
			gap: 0px;
			align-items: flex-start;
			justify-content: flex-start;
			align-self: stretch;
			flex-shrink: 0;
			position: relative;
		}

		.item {
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 0px 0px 1px 0px;
			padding: 12px 0px 12px 0px;
			display: flex;
			flex-direction: column;
			gap: 4px;
			align-items: flex-start;
			justify-content: center;
			align-self: stretch;
			flex-shrink: 0;
			position: relative;

			&:nth-last-child(1) {
				border-width: 0px 0px 0px 0px;
			}
		}
	}

	.notice-info-wrap {
		display: flex;
		flex-direction: row;
		gap: 8px;
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
	}

	.file-value {
		P {
			color: var(--color-grey-w, #b6bac0);
		}
	}

	.date {
		color: var(--color-grey-l, #83868a);
	}

	.view-wrap {
		display: flex;
		flex-direction: row;
		gap: 4px;
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;

		p {
			color: var(--color-grey-l, #83868a);
		}
	}

	.resource-content {
		width: 100%;
	}

	.mobile_item {
		border-top: 1px solid var(--color-grey-c, #e6e8ed);
	}

	.check-btn {
		padding: 12px 0;
	}

	.title {
		p {
			color: var(--color-black, #101010);
			text-align: left;
			font-family: 'Noto Sans KR', sans-serif;
			font-size: 14px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 600;
			position: relative;
			flex: 1;
			display: inline-block;
			width: 100%;
			white-space: break-spaces;
		}
	}

	.header {
		padding: 20px 20px 0 20px;
	}
`;
const tabletStyles = (0, styled_components_1.css) `
	display: flex;
	width: 100%;
	flex-direction: column;

	&.home {
		height: 100%;
	}

	.header {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: ${props => (props.$isTeacher ? 'space-between' : 'flex-end')};
		align-self: stretch;
		flex-shrink: 0;
		position: relative;

		.header-right {
			display: flex;
			gap: 12px;
			align-items: center;
			justify-content: space-between;
			width: 100%;
		}
	}

	.empty_data {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 100%;
	}

	.home-list-003 {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;

		.table-header {
			background: var(--color-silver, #f3f4f8);
			border-radius: 40px;
			padding: 12px 20px;
			display: flex;
			flex-direction: row;
			gap: 20px;
			align-items: flex-start;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			p {
				color: var(--color-grey, #666666);
				text-align: left;
				font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
				font-size: var(--b3-font-size, 14px);
				line-height: 150%;
				letter-spacing: var(--b3-letter-spacing, -0.02em);
				font-weight: var(--b3-font-weight, 400);
				position: relative;
				display: flex;
				align-items: center;
				justify-content: flex-start;
			}
		}

		.scroll-content {
			display: flex;
			flex-direction: column;
			gap: 0px;
			align-items: flex-start;
			justify-content: flex-start;
			flex: 1;
			position: relative;
		}

		.item {
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 0px 0px 1px 0px;
			padding: 12px 20px;
			display: flex;
			flex-direction: row;
			gap: 20px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			color: var(--color-black, #101010);
			font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b3-font-size, 14px);
			line-height: 150%;
			letter-spacing: var(--b3-letter-spacing, -0.02em);
			font-weight: var(--b3-font-weight, 400);

			&:nth-last-child(1) {
				border-width: 0px 0px 0px 0px;
			}
		}

		.body-item {
			overflow: hidden;
		}
	}

	.notice-list-001 {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		flex: 1;
		position: relative;
		height: unset;

		.body-item {
			overflow: hidden;
		}

		.table-header {
			background: var(--color-silver, #f3f4f8);
			border-radius: 40px;
			padding: 12px 20px 12px 20px;
			display: flex;
			flex-direction: row;
			gap: 12px;
			align-items: center;
			justify-content: flex-start;
			align-self: stretch;
			flex-shrink: 0;
			position: relative;

			p {
				color: var(--color-grey, #666666);
				text-align: center;
				font-family: 'Noto Sans KR', sans-serif;
				font-size: 14px;
				line-height: 150%;
				letter-spacing: -0.02em;
				font-weight: 400;
				position: relative;
				display: flex;
				align-items: center;
				justify-content: center;
			}
		}

		.scroll-content {
			display: flex;
			flex-direction: column;
			gap: 0px;
			align-items: flex-start;
			justify-content: flex-start;
			align-self: stretch;
			flex: 1;
			position: relative;
			box-sizing: border-box;
			height: unset;
		}

		.title p {
			-webkit-line-clamp: unset;
		}

		.item {
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 0px 0px 1px 0px;
			padding: 20px;
			display: flex;
			flex-direction: row;
			gap: 12px;
			align-items: center;
			justify-content: flex-start;
			align-self: stretch;
			flex-shrink: 0;
			position: relative;
			width: 100%;

			color: var(--color-black, #101010);
			font-family: 'Noto Sans KR', sans-serif;
			font-size: 14px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 400;

			.file {
				text-align: left;
				position: relative;
				display: flex;
				align-items: center;
				justify-content: center;
				gap: 4px;

				p {
					min-width: auto;
					color: var(--color-grey-w, #b6bac0);
					font-family: var(--h5-font-family, 'Noto Sans KR', sans-serif);
					font-size: var(--h5-font-size, 14px);
					line-height: 150%;
					font-weight: var(--h5-font-weight, 700);
				}
			}
		}
	}

	.resource-content {
		width: 100%;
	}
`;
const desktopStyles = (0, styled_components_1.css) `
	display: flex;
	width: 100%;
	flex-direction: column;
	height: 100%;

	.header {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: ${props => (props.$isTeacher ? 'space-between' : 'flex-end')};
		align-self: stretch;
		flex-shrink: 0;
		position: relative;

		.class-reservation {
			color: var(--color-black, #101010);
			text-align: left;
			font-family: var(--h3-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--h3-font-size, 24px);
			line-height: var(--h3-line-height, 36px);
			font-weight: var(--h3-font-weight, 700);
			display: flex;
			align-items: center;
			justify-content: flex-start;
		}

		.header-right {
			display: flex;
			gap: 12px;
			align-items: center;
			justify-content: flex-start;
		}
	}

	.home-list-003 {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;

		.table-header {
			background: var(--color-silver, #f3f4f8);
			border-radius: 40px;
			padding: 6px 28px 6px 28px;
			display: flex;
			flex-direction: row;
			gap: 20px;
			align-items: flex-start;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			p {
				color: var(--color-grey, #666666);
				text-align: left;
				font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
				font-size: var(--b3-font-size, 16px);
				line-height: var(--b3-line-height, 32px);
				letter-spacing: var(--b3-letter-spacing, -0.02em);
				font-weight: var(--b3-font-weight, 400);
				position: relative;
				display: flex;
				align-items: center;
				justify-content: flex-start;
			}
		}

		.scroll-content {
			display: flex;
			flex-direction: column;
			gap: 0px;
			align-items: flex-start;
			justify-content: flex-start;
			flex: 1;
			position: relative;
		}

		.item {
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 0px 0px 1px 0px;
			padding: 10px 6px 10px 6px;
			display: flex;
			flex-direction: row;
			gap: 24px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			color: var(--color-black, #101010);
			font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b3-font-size, 16px);
			line-height: var(--b3-line-height, 32px);
			letter-spacing: var(--b3-letter-spacing, -0.02em);
			font-weight: var(--b3-font-weight, 400);

			&:nth-last-child(1) {
				border-width: 0px 0px 0px 0px;
			}
		}

		.body-item {
			overflow: hidden;
		}
	}

	.notice-list-001 {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		flex: 1;
		position: relative;
		height: unset;

		.title p {
			-webkit-line-clamp: unset;
		}

		.body-item {
			overflow: hidden;
		}

		.table-header {
			background: var(--color-silver, #f3f4f8);
			border-radius: 40px;
			padding: 6px 28px 6px 28px;
			display: flex;
			flex-direction: row;
			gap: 24px;
			align-items: center;
			justify-content: flex-start;
			align-self: stretch;
			flex-shrink: 0;
			position: relative;

			color: var(--color-grey, #666666);
			text-align: center;
			font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b3-font-size, 16px);
			line-height: var(--b3-line-height, 32px);
			font-weight: var(--b3-font-weight, 400);
			position: relative;
			display: flex;
			align-items: center;
			justify-content: center;
		}

		.scroll-content {
			display: flex;
			flex-direction: column;
			gap: 0px;
			align-items: flex-start;
			justify-content: flex-start;
			flex: 1;
			position: relative;
			/* overflow: auto; */
			box-sizing: border-box;
			align-self: stretch;
			height: unset;
		}

		.item {
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 0px 0px 1px 0px;
			padding: 20px 28px 20px 28px;
			display: flex;
			flex-direction: row;
			gap: 24px;
			align-items: center;
			justify-content: flex-start;
			align-self: stretch;
			flex-shrink: 0;
			position: relative;

			.file {
				text-align: left;
				position: relative;
				display: flex;
				align-items: center;
				justify-content: center;
				gap: 4px;

				p {
					min-width: auto;
					color: var(--color-grey-w, #b6bac0);
					font-family: var(--h5-font-family, 'Noto Sans KR', sans-serif);
					font-size: var(--h5-font-size, 16px);
					line-height: var(--h5-line-height, 24px);
					font-weight: var(--h5-font-weight, 700);
				}
			}

			color: var(--color-black, #101010);
			font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b3-font-size, 16px);
			line-height: var(--b3-line-height, 32px);
			font-weight: var(--b3-font-weight, 400);
		}
	}

	.body-item {
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
`;
/**
 * 'No'(번호) 칼럼에 쓸 화면 표시 번호를 매긴다.
 *
 * 서버 고유번호(item.index)를 그대로 쓰지 않는 이유: 고유번호는 등록 시점에 매겨져 저장되는
 * 값이라 중간 글을 지우면 결번이 생긴다(4,3,2,1 에서 3번 삭제 시 화면에 4,2,1). 운영 요청에 따라
 * DB 원본은 그대로 두고 화면 번호만 "남아있는 글 기준"으로 다시 매긴다.
 *
 * 계산 근거 — 서버가 pin_importance 필터로 내려주는 응답 구조:
 *   (1) 상단 고정 필독 블록 important_count 개
 *   (2) 그 아래 일반 리스트(위 필독 글이 중복으로 한 번 더 들어있음)
 * 이 둘을 이어붙인 하나의 내림차순 시퀀스가 응답이고, 그 전체 길이가 total_count 다.
 * 페이지네이션(offset = page * count)도 이 시퀀스 기준으로 동작하므로,
 *   실제 게시글 수 = total_count - important_count
 *   전체 시퀀스 위치(seqIndex) = page * count + 행 위치
 *   표시 번호 = 실제 게시글 수 - (seqIndex - important_count)
 * 가 페이지를 넘어가도 끊김 없이 이어진다. (dev 실데이터로 전 페이지 검증 완료)
 *
 * 검색 시에는 서버가 검색 결과 기준으로 두 카운트를 다시 내려주므로 같은 식이 그대로 성립한다
 * (필독 글이 검색에 걸리면 검색 결과에도 고정 블록으로 중복되어 내려온다 — 실측 확인).
 *
 * 상단 고정 필독 블록은 번호 대신 '필독'을 표시하므로 number:-1 로 둔다.
 * 홈 목록의 필독 표시(OpenItem importantAndtitleAndFiles)도 이 값을 본다.
 */
const withDisplayNumbers = (arr, { page, count, totalCount, importantCount, leadingPinCount, }) => {
    const realCount = Math.max(0, totalCount - importantCount);
    return arr.map((item, idx) => {
        if (idx < leadingPinCount)
            return { ...item, number: -1 };
        const seqIndex = page * count + idx;
        const displayNumber = realCount - (seqIndex - importantCount);
        // 정상 범위를 벗어나면(서버 응답 구조가 가정과 달라진 경우) 0·음수를 노출하는 대신
        // 기존 동작인 서버 고유번호로 물러난다. 번호가 비어 보이는 것보다 낫다.
        if (displayNumber < 1 || displayNumber > realCount) {
            return { ...item, number: item.index };
        }
        return { ...item, number: displayNumber };
    });
};
exports.OpenTable = react_1.default.memo(({ isResource = false, isTeacher = false, isHome = false, defaultOpen, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const historyStore = (0, GlobalStateProvider_1.useHistoryStore)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { isDesktop, isTablet, isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const [initLoad, setInitLoad] = (0, react_1.useState)(false);
    const [selectedId, setSelectedId] = (0, react_1.useState)();
    const [page, setPage] = (0, react_1.useState)(0);
    const [testData, setTestData] = (0, react_1.useState)([]);
    const [totalCount, setTotalCount] = (0, react_1.useState)(0);
    const [count, setCount] = (0, react_1.useState)(isHome ? 5 : 10);
    const [checkedList, setCheckedList] = (0, react_1.useState)([]);
    const [searchOption, setSearchOption] = (0, react_1.useState)({});
    const { headTitleList, tableReadDataKeys } = react_1.default.useMemo(() => {
        // 기본적인 항목들
        const headTitleList = isMobile && isTeacher
            ? []
            : [
                ...(isHome
                    ? []
                    : [
                        { title: 'no', space: 1, maxWidth: 45 },
                        { title: 'content', space: 4, sort: false },
                        ...(isMobile
                            ? []
                            : [
                                { title: 'attachFile', space: 1 },
                                { title: 'views', space: 1 },
                                ...(isTeacher
                                    ? [{ title: 'author_name', space: 1 }]
                                    : []),
                            ]),
                        { title: 'creation_time', space: 1 },
                    ]),
            ];
        const tableReadDataKeys = [
            ...(isHome
                ? [
                    {
                        title: 'importantAndtitleAndFiles',
                        space: 2,
                        sort: false,
                    },
                    { title: 'creation_time', space: 1 },
                ]
                : [
                    ...(isMobile && isTeacher
                        ? []
                        : [{ title: 'no', space: 1, maxWidth: 45 }]),
                    { title: 'title', space: 4 },
                    ...(isMobile
                        ? []
                        : [
                            { title: 'files', space: 1 },
                            { title: 'views', space: 1 },
                            ...(isTeacher ? [{ title: 'author_name', space: 1 }] : []),
                        ]),
                    { title: isMobile ? 'fileAndTime' : 'creation_time', space: 1 },
                ]),
        ];
        // useMemo에서 반환
        return { headTitleList, tableReadDataKeys };
    }, [isHome, isMobile, isTablet, isTeacher]);
    const { data, refetch } = (0, posts_1.useNoticeList)({
        ...(searchOption ? { ...searchOption } : {}),
        type: isResource ? 'study_data' : 'notice',
        offset: page === 0 ? 0 : page * count,
        limit: count,
        // 서버에서 필독(importance) 게시글을 상단에 고정하고,
        // 그 아래 일반 리스트에도 고유번호 내림차순으로 누락 없이(중복 허용) 내려준다.
        // 이 필터 사용 시 정렬은 서버가 처리하므로 orderby는 보내지 않는다.
        pin_importance: true,
    });
    // (리스트 갱신
    const refetchList = (0, throttle_1.default)(refetch, 1000, { leading: true, trailing: false });
    // 이벤트 등록 - 리스트 갱신
    (0, react_1.useEffect)(() => {
        APP.eventManager.subscribe(constant_1.REFRESH_POSTS_LIST, refetchList);
        return () => {
            APP.eventManager.unsubscribe(constant_1.REFRESH_POSTS_LIST, refetchList);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        const initializeState = () => {
            const previousPage = historyStore.getRecentPageHistory(isResource ? 'resourcePage' : 'noticePage');
            const searchOptions = previousPage?.searchOption;
            setSearchOption(searchOptions || {});
            setPage(previousPage?.prePage || 0);
            setInitLoad(true);
        };
        initializeState();
        return () => {
            setInitLoad(false);
            setSearchOption({});
        };
    }, [isResource]);
    (0, react_1.useEffect)(() => {
        if (selectedId !== defaultOpen)
            setSelectedId(defaultOpen);
    }, [defaultOpen]);
    (0, react_1.useEffect)(() => {
        if (data) {
            const { total_count, found_count, items, important_count } = data;
            if (total_count > 0 && found_count === 0) {
                const maxPage = Math.max(0, Math.ceil(total_count / count) - 1);
                setPage(maxPage);
                return;
            }
            // 상단 고정 필독 블록은 첫 페이지에만 노출되므로 leadingPinCount는 page 0에서만 적용.
            // 반면 번호 계산에 쓰는 importantCount는 전체 시퀀스 기준이라 모든 페이지에서 동일하다.
            const importantCount = important_count || 0;
            const leadingPinCount = page === 0 ? importantCount : 0;
            const numbersItem = withDisplayNumbers(items, {
                page,
                count,
                totalCount: total_count || 0,
                importantCount,
                leadingPinCount,
            });
            setTotalCount(isHome ? Math.min(total_count, 5) : total_count);
            setTestData(numbersItem);
            return;
        }
        setTestData([]);
        setTotalCount(0);
    }, [data]);
    (0, react_1.useEffect)(() => {
        if (isHome) {
            setCount(5);
        }
        else {
            setCount(10);
        }
    }, [isHome, isResource]);
    (0, react_1.useEffect)(() => {
        if (!initLoad)
            return;
        if (count <= 0)
            return;
        refetchList();
    }, [count, page, searchOption, isResource, selectedId, initLoad]);
    const handlerMoreData = (page) => {
        if (isHome) {
            return;
        }
        setPage(page);
    };
    // 상단 레이아웃 검색 조건을 위한 action
    const handlerFilterList = (filter) => {
        setSearchOption(filter);
    };
    const renderTitle = (0, react_1.useMemo)(() => {
        const showNoticeHeaderTitle = isDesktop && !isResource && !isHome;
        return (react_1.default.createElement("div", { className: "header", style: {
                alignSelf: !isTeacher && 'flex-end',
                justifyContent: showNoticeHeaderTitle ? 'space-between' : undefined,
                width: '100%',
            } },
            showNoticeHeaderTitle && react_1.default.createElement("div", { className: "class-reservation" }, t('menu.notice')),
            react_1.default.createElement("div", { className: "header-right" },
                isTeacher && !isMobile && (react_1.default.createElement(DeleteResourceItem_1.DeleteResourceItem, { isOneDel: false, menu: isResource ? 'resource' : 'notice', deleteList: checkedList })),
                react_1.default.createElement(common_1.SearchBar, { className: `${!isMobile ? 'search-bar-qna' : 'search-bar-mobile'}`, filterData: "title", defaultSearchContent: searchOption['title'], handlerFilterList: handlerFilterList }))));
    }, [isTeacher, isResource, checkedList, isDesktop, isHome, isMobile, searchOption, t]);
    const handlerSelectItem = (item) => {
        if (!item)
            return;
        // 새로운 페이지로 이동할 때 현재 상태를 기록
        const historyItem = {
            preItems: {},
            props: {
                isResource,
                isTeacher,
                isHome,
            },
            prePage: page,
            searchOption: searchOption,
            pageName: isResource ? 'resourcePage' : 'noticePage',
        };
        historyStore.pushHistory(historyItem);
        dispatch((0, action_1.updateMenu)(isResource ? 'learningSupportRoom' : 'notice', { menu: isResource ? 'resource' : 'notice', detail: 'detail' }, selectedId, {
            item,
            isResource,
            selectedId: item.id,
        }));
    };
    const renderItem = (item, styles) => {
        if (!item)
            return;
        return tableReadDataKeys.map((headItem, index) => (react_1.default.createElement("div", { key: index, className: `body-item ${headItem.title}`, style: {
                flex: !isMobile && headItem.space,
                cursor: 'pointer',
                ...styles?.bodyItem,
                maxWidth: headItem?.maxWidth,
                width: isMobile && headItem.title === 'title' ? '100%' : 'unset', //학습지원실 제목 잘리게 하기 위해
            } },
            react_1.default.createElement(OpenItem_1.OpenItem, { key: item.id, item: item, headItem: headItem, isMobile: isMobile, isTablet: isTablet, isTeacher: isTeacher }))));
    };
    const renderEmpty = (0, react_1.useMemo)(() => react_1.default.createElement(option_1.EmptyTable, { title: `supportRoom.${isResource ? 'resource' : 'notice'}Empty` }), [isResource]);
    const renderGuidItem = (0, react_1.useMemo)(() => (react_1.default.createElement(DeleteResourceItem_1.DeleteResourceItem, { isOneDel: false, menu: isResource ? 'resource' : 'notice', deleteList: checkedList })), [checkedList, isResource]);
    return (react_1.default.createElement(OpenTableStyled, { "$isDesktop": isDesktop, "$isTablet": isTablet, "$isMobile": isMobile, "$isHome": isHome, "$isTeacher": isTeacher, className: `task-board-container open-table ${isHome && 'home'}` },
        react_1.default.createElement(common_1.Table, { className: isHome ? 'home-list-003 ' : 'notice-list-001', showCheckBox: isTeacher ? true : false, isInfinite: isHome ? true : false, selectedId: selectedId, page: page, data: testData, totalCount: totalCount, headTitleList: headTitleList, renderGuidItem: isTeacher && isMobile && !isHome && renderGuidItem, renderTitle: !isHome && renderTitle, renderItem: renderItem, renderEmpty: totalCount <= 0 && renderEmpty, handlerMoreData: handlerMoreData, handlerCheckList: setCheckedList, handlerSelectItem: handlerSelectItem, forceShowheader: isMobile && !isTeacher ? false : true, padding: !isHome })));
});
